// extracted by mini-css-extract-plugin
export var avatar = "_rl-3";
export var avatarContainer = "_rl-2";
export var avatarSpacer = "_rl-5";
export var avatarSpacerContainer = "_rl-4";
export var avatarStackContainer = "_rl-1";
export var bubble = "_rl-0";
export var remainderBubble = "_rl-6";